import React, { useEffect, useMemo, useState } from 'react';
import { ItemListItem } from './ItemListItem';
import KitItemCard from './KitItemCard';
import { AetherItemType, OrderItem } from '../../models/OrderItem';
import { useAppSelector } from '../../redux/hooks';
import { selectDebug } from '../../redux/selectors/checkoutSelectors';
import { Stack, Pagination } from '@mui/material';

export default function ItemList({
  items,
  pageMax,
  big,
}: Readonly<{ pageMax: number; items: OrderItem[], big?: boolean }>) {
  const debug = useAppSelector(selectDebug);

  const [page, setPage] = useState<number>(1);

  const filteredItems = useMemo(
    () =>
      items?.filter(
        (i) =>
          (i.aetherData.aetherItemType === AetherItemType.PRODUCT || debug) &&
          !i.aetherData.isKitChildProduct,
      ) ?? [],
    [items, debug],
  );

  const pageCount = Math.ceil(filteredItems.length / pageMax);

  useEffect(() => {
    setPage(1);
  }, [pageMax]);

  const handlePageChange = (_: React.ChangeEvent<unknown>, page: number) => {
    setPage(page);
  };

  return (
    <>
      {filteredItems
        ?.slice((page - 1) * pageMax, (page - 1) * pageMax + pageMax)
        ?.map((item, idx) => (
          <React.Fragment key={item.id}>
            {!item.aetherData.isKitProduct && (
              <ItemListItem key={item.id} item={item} data-testid={'listItem' + idx} big={big} />
            )}
            {item.aetherData.isKitProduct && (
              <KitItemCard
                key={item.id}
                parentItem={item}
                childItems={(items ?? []).filter(
                  (i) =>
                    i.aetherData.isKitChildProduct && item.aetherData.kitId === i.aetherData.kitId,
                )}
                index={idx}
                big={big}
              />
            )}
          </React.Fragment>
        ))}
      {filteredItems.length > pageMax && (
        <Stack direction={'row'} justifyContent={'center'} mb={2}>
          <Pagination page={page} onChange={handlePageChange} count={pageCount} color="primary" />
        </Stack>
      )}
    </>
  );
}
